module.exports = __webpack_public_path__ + "img/checked_icon.15cb28f7.svg";